import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=6bd65cbf"
import script from "./Notificaciones.vue?vue&type=script&lang=js"
export * from "./Notificaciones.vue?vue&type=script&lang=js"
import style0 from "./Notificaciones.vue?vue&type=style&index=0&id=6bd65cbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports